import Typography from "@portal/components/atoms/v2/typography";
import { MainBox } from "../components/mainBox";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { useRobot } from "@portal/app/context/robotProvider";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";

export const RelevencePage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const { riskLevelRequest: request, setRelevantEducationOrJob } = useRobot();
  const isButtonDisabled = request.relevantEduationOrJob === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_2_A, texts.PAGE_2_B];

  const OnSelectionClick = (selectedOption: number) => {
    setRelevantEducationOrJob(selectedOption === 1);
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_2_SUBHEADER}</Typography>
        <TextLine />
        <SelectionBoxComponent
          options={options}
          selectedOption={GetOption(request.relevantEduationOrJob) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};

function GetOption(relevence: boolean | null) {
  if (relevence === null) return null;
  return relevence ? 1 : 0;
}
